import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MoveRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M18 8L22 12L18 16' }],
    ['path', { d: 'M2 12H22' }],
  ],
];

export default MoveRight;
